/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import * as moment from 'moment';
@Component({
  selector: 'app-archived',
  templateUrl: './archived.page.html',
  styleUrls: ['./archived.page.scss'],
})
export class ArchivedPage {
  user: any;
  archivedMessages: any = [];
  page: number;
  perPage: number;
  hasMore: boolean;
  hasSkelton: boolean;
  nodata: boolean;
  constructor(
    public apiService: ApiService,
    public toastService: ToastService,
    public navCtrl: NavController
  ) {}

  ionViewWillEnter() {
    this.page = 1;
    this.perPage = 10;
    this.hasMore = true;
    this.archivedMessages=[];
    this.getArchivedmessages();
  }


  getArchivedmessages() {
    this.hasSkelton = true;
    const params = {
      page: this.page,
      perPage: this.perPage,
    };
    this.apiService.post('user/get-messages', params).subscribe(
      (res) => {
        this.hasSkelton = false;
        if (res.error === false) {
          res.data.archived.forEach((p) => {
            this.archivedMessages.push(p);
          });
          if (res.data.inbox.length < this.perPage) {
            this.hasMore = false;
          } else {
            this.page++;
          }
          if (!this.archivedMessages.length) {
            this.nodata = true;
          }
        }
      },
      (err) => {
        this.hasSkelton = false;
      }
    );
  }

  doInfinite(infiniteScroll) {
    if (this.hasMore) {
      this.getArchivedmessages();
      setTimeout(() => {
        infiniteScroll.target.complete();
      }, 1000);
    } else {
      infiniteScroll.target.complete();
      infiniteScroll.target.disabled = true;
    }
  }

  messageInfo(data) {
    this.navCtrl.navigateForward('/messageDetail', {
      state: { data },
    });
  }

}
